import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import ROUTES from '../../assets/routes'
import { matchRoute } from '../../util/routes'
import pathStepsMap from './tourStepsMap'
import { TourStep } from './tour.typings'

/** Route patterns in match order: the more specific screener and FII/DII paths come first. */
const TOUR_ROUTES = [
    { path: ROUTES.chart, key: 'chart' },
    { path: ROUTES.symbol, key: 'chart' },
    { path: ROUTES.optionChain, key: 'option-chain' },
    { path: ROUTES.oiOverview, key: 'oi-analysis' },
    { path: ROUTES.openInterestChange, key: 'oi-analysis' },
    { path: ROUTES.openInterest, key: 'oi-analysis' },
    { path: ROUTES.multiStrikeChart, key: 'oi-analysis' },
    { path: ROUTES.screenerExplore, key: 'screener-explore' },
    { path: ROUTES.screener, key: 'screener' },
    { path: ROUTES.fiiDiiSummary, key: 'fii-dii' },
    { path: ROUTES.fiiDiiFuturesOptions, key: 'fii-dii' },
    { path: ROUTES.fiiDiiCashMarket, key: 'fii-dii' },
    { path: ROUTES.fiiDiiFiiHistory, key: 'fii-dii' },
    { path: ROUTES.fiiDii, key: 'fii-dii' },
    { path: ROUTES.strategyBuilder, key: 'strategy-builder' },
    { path: ROUTES.scalper, key: 'scalper' }
]

/**
 * Guided-tour steps written for the current route, or an empty list. The list covers every state
 * of the page; `resolveTourSteps` picks the steps whose targets are on screen when the tour starts.
 */
export const useRouteTourSteps = (): TourStep[] => {
    const location = useLocation()
    return useMemo(() => {
        const matched = matchRoute(location.pathname, TOUR_ROUTES)
        return matched && pathStepsMap[matched] ? pathStepsMap[matched] : []
    }, [location.pathname])
}
